export function parseApiError(status: number, body: string): string {
  try {
    const parsed = JSON.parse(body);
    if (parsed.detail) {
      if (typeof parsed.detail === "string") return parsed.detail;
      if (Array.isArray(parsed.detail)) {
        const messages = parsed.detail
          .map((e: { msg?: string }) => e.msg)
          .filter(Boolean);
        if (messages.length > 0) return messages.join("; ");
      }
    }
    return `Request failed (${status})`;
  } catch {
    if (body && body.length < 200) return body;
    return `Request failed (${status})`;
  }
}
